// Navigation
export const updateNavType = (navType) => ({
  type: 'UPDATE_NAV_TYPE',
  navType,
});

export const updateNavColor = (navBarColor) => ({
  type: 'UPDATE_NAV_COLOR',
  navBarColor
});